import React from "react";

const FormSection = ({ title, subtitle, children, className = "" }) => {
  return (
    <div className="form-section">
      {(title || subtitle) && (
        <div className="mb-6">
          {title && (
            <h3 className="section-title">
              {title}
            </h3>
          )}
          {subtitle && (
            <p className="section-subtitle">
              {subtitle}
            </p>
          )}
        </div>
      )}

      {children}
    </div>
  );
};

export default FormSection;